import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const stmsupplierApi = createApi({
	reducerPath: "stmsupplierApi",
	baseQuery: btBaseQuery,
	tagTypes: ["Supplier"],

	endpoints: (builder) => ({
		getSuppliers: builder.query<st_msupplier[], string>({
			query: (cid) => `supplier/${cid}`,
			providesTags: ["Supplier"],
		}),
		getSupplier: builder.query<st_msupplier, string>({
			query: (id) => `supplier/byid/${id}`,
		}),
		insertSupplier: builder.mutation({
			query: (supplier) => ({
				url: `/supplier/`,
				method: "POST",
				body: supplier,
			}),
			invalidatesTags: ["Supplier"],
		}),
		updateSupplier: builder.mutation({
			query: (supplier) => ({
				url: `/supplier/`,
				method: "PUT",
				body: supplier,
			}),
			invalidatesTags: ["Supplier"],
		}),
		deleteSupplier: builder.mutation({
			query: (supplier) => ({
				url: `/supplier/${supplier.sp_id}`,
				method: "DELETE",
				body: supplier,
			}),
			invalidatesTags: ["Supplier"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetSuppliersQuery,
	useGetSupplierQuery,
	useInsertSupplierMutation,
	useUpdateSupplierMutation,
	useDeleteSupplierMutation,
} = stmsupplierApi;
